export default {
  sections: {
    my_area: "Aho Nkorera",
    administration: "Ubuyobozi",
  },

  items: {
    my_dashboard: "Ahabanza",
    my_statement: "Inyandiko y’Imari",
    my_contributions: "Imisanzu",
    my_loans: "Inguzanyo",
    my_loans_list: "Inguzanyo",
    loan_applications: "Gusaba inguzanyo",
    my_penalties: "Ibihano",
    my_withdrawals: "Kubikuza",

    admin_overview: "Incamake",
    members: "Abanyamuryango",
    finance: "Imari",
    statement: "Inyandiko y’Imari",
    contributions: "Imisanzu",
    expenses: "Ibyasohotse",
    penalties: "Ibihano",
    withdrawals: "Kubikuza",
    reconciliation: "Kugenzura Imibare",
    matrix_report: "Raporo y’Imbonerahamwe",

    loans: "Inguzanyo",
    all_loans: "Inguzanyo Zose",
    repayment_sheet: "Urupapuro rw’Ubwishyu",
    bulk_loan_migration: "Kwimura Inguzanyo Nyinshi",
    loan_applications_review: "Ubusabe bw’Inguzanyo",

    investments: "Ishoramari",
    commitments: "Ibyiyemejwe",
    settings: "Igenamiterere",
    financial_years: "Imyaka y’Imari",
    fy_closure: "Gusoza Umwaka w’Imari",
    group_rules: "Amategeko y’Itsinda",
  },
};
